document.addEventListener("DOMContentLoaded", function () {

  const buttons = document.querySelectorAll(".footer_boton");

  buttons.forEach(function (button) {

    const content = button.nextElementSibling;

    const arrowDown = button.querySelector(".bi-chevron-down");
    const arrowUp = button.querySelector(".bi-chevron-up");

    button.addEventListener("click", function () {

      const isOpen = window.getComputedStyle(content).display === "block";

      if (isOpen) {
        content.style.display = "none";
        button.setAttribute("aria-expanded", "false");

        if (arrowDown) arrowDown.style.display = "inline-block";
        if (arrowUp) arrowUp.style.display = "none";

      } else {
        content.style.display = "block";
        button.setAttribute("aria-expanded", "true");

        if (arrowDown) arrowDown.style.display = "none";
        if (arrowUp) arrowUp.style.display = "inline-block";
      }

    });

  });

});